import React, {PureComponent} from 'react';
import InputRegular from '../../common/InputRegular';

class ViberSelectPlan extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            planType: ''
        };
    }

    componentDidMount() {

    }

    handleGoToSecondStep = () => {
        this.props.handleStepChange(2)
    }

    render() {
        return (
            <div className='add-funds-content-container'>
                <div className='stripe-loader-redirect no-background'>
                    <h2>CHOOSE YOUR VIBER BUSINESS<br/>
                        MONTHLY SUBSCRIPTION</h2>
                    <div className='main-container'>
                        <div className='select-container'>
                            <div
                                className={this.props.selectedPlan === 'Region A' ? 'single-selection active' : 'single-selection'}
                                onClick={()=>this.props.updateSelectPlan('Region A')}
                            >
                                <img src='/img/viber/globe-europe-solid.png'/>
                                <div className='title-container'>
                                    <h3>Viber Business</h3>
                                    <p>Region A</p>
                                </div>
                                <p className='price'><span>$200</span>/month</p>


                                <p className='bottom-text blue-text'><span className='small-text'>Send campaigns
                                        to:</span><br/>
                                    Russia, Belarus, Bulgaria, Greece,
                                    Hungary, Iraq, Moldova, Ukraine</p>

                                <div className='credits-included-container'>
                                    <p><span>13k</span> /month<br/>
                                        Viber Credits Included</p>
                                </div>
                            </div>
                            <div
                                className={this.props.selectedPlan === 'Region B' ? 'single-selection active' : 'single-selection'}
                                onClick={()=>this.props.updateSelectPlan('Region B')}
                            >
                                <img src='/img/viber/globe-americas-solid.png'/>
                                <div className='title-container'>
                                    <h3>Viber Business</h3>
                                    <p>Region B</p>
                                </div>
                                <p className='price'><span>$150</span>/month</p>
                                <p className='bottom-text blue-text'><span className='small-text'>Send campaigns
                                        to:</span><br/>
                                    All other countries</p>
                                {
                                    this.state.anyOtherLoader ?
                                        <img className='any-other-loader-img' src="/img/chart-loader.svg" alt="Loading..." alt=""/>
                                        :
                                        ''
                                }
                                <div className='credits-included-container'>
                                    <p><span>10k</span> /month<br/>
                                        Viber Credits Included</p>
                                </div>
                            </div>
                        </div>
                        <p className='bottom-link'>Your Viber Business Subscription Comes With Included<br/>
                            <a>Viber Monthly Prepaid Credits</a>.</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default ViberSelectPlan;